// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 885) return "static/chunks/75fc9c18-1abb53e5b7d3fe647c4f.js";
	if (chunkId === 744) return "static/chunks/744-8a5b1387f84be1c2db84.js";
	if (chunkId === 331) return "static/chunks/331-4ea299fcdeda35760a0a.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"145":"24a2fd88","820":"c9872ff3"}[chunkId] || chunkId) + "." + {"79":"897441beed1027405f5e","132":"3478d81df83dccb71ba4","145":"0a61ec6e480379fc206f","456":"3d8554e811c92fff4dbc","526":"8455d04c769ddb7b50c0","765":"aedb4380f29ab8258a86","820":"67a1b1c3063594984838"}[chunkId] + ".js";
};